import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from './../../../environments/environment';
import { CfetBaseComponent, LoaderService, UrlUtil, CfetService, CFETILMEndpointsConstant, CfetPageNamesConstant } from '../../cfet-core';

@Component({
    selector: 'app-affiliation-code-utf',
    templateUrl: './affiliation-code-utf.component.html',
    styleUrls: ['./affiliation-code-utf.component.scss'],
    standalone: false
})
export class AffiliationCodeUtfComponent extends CfetBaseComponent implements OnInit {
  public affiliateName: string;
  getorgInfo: any;
  orgId: any;
  jobfunction: any;
  checkstateAndZip = { 'state': '', 'zipcode': '' };
  companyInfo: {};
  orgDetailInfo: { org_name: any; address: any; city: any; state: any; zipcode: any; isPSEAffliationcode: any; isEVSP: any };
  streetAddress: any;
  isSpaOrg: any;
  org_name: any;
  orgStreetAddress: any;
  orgState: any;
  zipCodePin: any;
  orgCity: any;
  addressLine2: any;
  showLoading: boolean = false;
  returnUrl = '';
  affiliationCode: any;
  isEVSP: boolean = false;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private cfetService: CfetService,
    private urlUtil: UrlUtil,
    private title: Title) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.eligibility_utfHtmlTitle);
    this.cfetService.isLandingPage.next(false);
    if (sessionStorage.getItem('orgInfo')) {
      this.getorgInfo = JSON.parse(sessionStorage.getItem('orgInfo'));
      this.orgId = this.getorgInfo.orgid;
      this.affiliateName = this.getorgInfo.orgName;
      this.isSpaOrg = this.getorgInfo.isSpaOrg;
    }
    if (sessionStorage.getItem('returnUrl')) {
      this.returnUrl = JSON.parse(sessionStorage.getItem('returnUrl'));
    }
    window.scrollTo(0, 0);
    this.title.setTitle(this.cfetTitles.eligibility.utfHtmlTitle);
    this.cfetService.isLandingPage.next(false);
    this.activatedRoute.queryParams.subscribe(params => {
      console.log('Full params:', params);
      let code = this.urlUtil.getQueryParamCaseInsensitive(params, 'affiliationcode');
      if (!code) {
        code = sessionStorage.getItem('affiliationCode');
      }
      console.log('Final affiliation code:', code);
      // When the previous screen already resolved the org (eligibility URL flow
      // or utf-landing), display it directly and skip a second lookup that left
      // the spinner running.
      const storedOrg = sessionStorage.getItem('orgInfo');
      if (storedOrg) {
        this.getorgInfo = JSON.parse(storedOrg);
        if (this.getorgInfo && this.getorgInfo.orgName) {
          this.orgId = this.getorgInfo.orgid;
          this.affiliateName = this.getorgInfo.orgName;
          this.isSpaOrg = this.getorgInfo.isSpaOrg;
          if (code) {
            this.affiliationCode = code;
            sessionStorage.setItem('affiliationCode', code);
          }
          return;
        }
      }
      if (code) {
        this.affiliationCode = code;
        sessionStorage.setItem(
          'affiliationCode',
          code
        );
        console.log(
          'Calling validateAffiliationCode'
        );
        this.validateAffiliationCode(code);
      }
    });
    if (sessionStorage.getItem('returnUrl') && sessionStorage.getItem('returnUrl').length !== 0) {
      this.returnUrl = JSON.parse(sessionStorage.getItem('returnUrl'));
    }
  }
validateAffiliationCode(code: string) {
    const param = { retcode: code };
    const url = this.urlUtil.formatURlParams(
      CFETILMEndpointsConstant.GET_AFFILIATION_CODE,
      param
    );
    this.showLoading = true;
    this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
      this.showLoading = false;
      console.log('Affiliation API response:', data);
      if (data && data.profile && data.profile.length > 0) {
        this.orgId = data.orgid;
        this.affiliateName = data.orgName;
        data.profile.forEach(val => {
          if (
            val.attribute_name === 'isSpaOrg' &&
            val.attribute_value === 'TRUE'
          ) {
            this.isSpaOrg = true;
          }
        });
        const orgInfo = {
          orgid: data.orgid,
          orgName: data.orgName,
          isSpaOrg: this.isSpaOrg
        };
        sessionStorage.setItem('orgInfo', JSON.stringify(orgInfo));
        sessionStorage.setItem('affiliationCode', code);
        console.log('Stored affiliationCode:', code);
        console.log('Stored orgInfo:', orgInfo);
      }
    }, () => {
      this.showLoading = false;
    });
  }
  continue(event) {
    console.log('before naviagtion url:', window.location.href);
    sessionStorage.setItem('fromAffiliationContinue', 'true');
    this.router.navigate(
      [CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF]
    ).then(() => {
      window.history.replaceState({}, '', '/signup/orgAssignment');
      console.log('after naviagtion url:', window.location.href);
    });

  }

  cancel(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (this.returnUrl) {
        if (this.returnUrl.indexOf('?') === -1) {
          this.redirectUrl(encodeURIComponent(this.returnUrl + '?fnStatus=ineligible'));
        } else {
          this.redirectUrl(encodeURIComponent(this.returnUrl + '&fnStatus=ineligible'));
        }
      } else {
        const url = environment.plp_page;
        this.redirectUrl(encodeURIComponent(url + '&fnStatus=ineligible'));
      }
    }
  }


  isEncoded (url) {
    if (url !== '') {
      return url !== decodeURIComponent(url);
    }
  }

  redirectUrl (url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    } else {
      window.location.href = url;
    }
  }

  getOrgProfile () {
    this.companyInfo = {};
    if (this.orgId.length > 0) {
      const param = { xorgid: this.orgId };
      const url = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_ORG_PROFILE, param)}`;
      this.showLoading = true;
      this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
        sessionStorage.setItem('oraInformation', JSON.stringify(this.getOraInformation(data)));
        this.showLoading = false;
        window.scrollTo(0, 0);
        if (data && data.profile) {
          data.profile.forEach(val => {
            this.companyInfo[val.attribute_name] = val.attribute_value ?? val.attribute_mvalue;
          });
          this.addressLine2 = this.companyInfo['Address 2'] ? this.companyInfo['Address 2'] : '';
          this.streetAddress = (this.addressLine2 !== '') ? (String(this.companyInfo['Address 1']) + ',' + this.addressLine2) : this.companyInfo['Address 1'];
          console.log ('getOrgProfile:this.companyInfo[isEVSP]:' + this.companyInfo['isEVSP']);
          const isevspValue = this.companyInfo['isEVSP'];
          if (isevspValue !== null && isevspValue === 'TRUE') {
            this.isEVSP=true;
          } else {
            this.isEVSP = false;
          }
          console.log ('getOrgProfile:isEVSP: ' + this.isEVSP);
          this.orgDetailInfo = {
            org_name: data.orgName,
            address: this.streetAddress,
            city: this.companyInfo['city'],
            state: this.companyInfo['state'],
            zipcode: this.companyInfo['zipcode'],
            isPSEAffliationcode: true,
            isEVSP: this.isEVSP
          };
          console.log ('getOrgProfile:this.orgDetailInfo.isEVSP:' + this.orgDetailInfo.isEVSP);
          // Show Organization Details for Non spa org
          sessionStorage.setItem('orgDetailInfo', JSON.stringify(this.orgDetailInfo));
          this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF]);
        }
      }, (error1) => {
        this.loaderService.hideLoading();
      });
    }
  }

  getOraInformation(json: any): { ora_required: string; ora_required_attributes: string[] } {
    const oraRequiredAttribute = json.profile.find(attr => attr.attribute_name === 'ora_required');
    const oraRequiredAttributes = json.profile.find(attr => attr.attribute_name === 'ora_required_attributes');

    if (!oraRequiredAttribute || !oraRequiredAttributes) {
      return {
        ora_required: 'N',
        ora_required_attributes: []
      };
    }

    if (oraRequiredAttribute.attribute_value === 'Y') {
      return {
        ora_required: 'Y',
        ora_required_attributes: oraRequiredAttributes.attribute_mvalue
      };
    } else {
      return {
        ora_required: 'N',
        ora_required_attributes: []
      };
    }
  }

}
